import { mt, mb, py } from 'styled-components-spacing'; // eslint-disable-line object-curly-newline

import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import Grid from 'styled-components-grid';

export const StyledCover = styled.div`
  max-width: 1200px;
  margin: auto;
  width: 100%;
  margin-top: 30px;
  ${breakpoint('mobile', 'tablet')`
    height: auto;
    margin-top: 40px;
    color: #1D2B4E;
  `}

  ${breakpoint('tablet', 'desktop')`
    padding-top: 1rem;
    margin-top: 1rem;
  `}

`;

export const StyledHeading = styled.div`
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  color:#136C9D;
  ${mb(4.5)};
  ${mt(5)};
  ${breakpoint('mobile', 'tablet')`
    font-size: 25px;
    ${mt(4.5)};
    ${mb(4)};
  `}
  ${breakpoint('tablet', 'desktop')`
    font-size: 29px;
    ${mt(4)};
  `}
`;

export const StyledPartnerHospital = styled(Grid)`
  display: grid;
  grid-template-columns: repeat(6, auto); 
  justify-items: center;
  align-items: center;
  width:100%;
  ${breakpoint('mobile', 'tablet')`
    grid-template-columns: repeat(4, 1fr); 
    svg{
      height: 60px;
      width: 60px;
    }
  `}
   @media (min-width:600px)  and (max-width:736px) {
    svg{
        height: 80px;
        width: 80px;
    }  
      }
  ${breakpoint('tablet', 'desktop')`
   grid-template-columns: repeat(4, 1fr); 
     svg{
      margin-left:0.5rem;
      margin-right:0.5rem;
     } 
  `}
`;

export const StyledHospital = styled.img`
  ${breakpoint('mobile', 'tablet')`
    width: 55px;
  `}
  ${breakpoint('tablet', 'desktop')`
    width: 100px;
  `}
`;

export const StyledDiv = styled.div`
  ${breakpoint('desktop')`
    padding: 15px 0px;
  `}
   ${breakpoint('mobile', 'tablet')`
      width:70px;
      display: flex;
      justify-content: center;
      padding: 10px 0px;
  `}
  ${breakpoint('tablet', 'desktop')`
      width: 100px;
      ${py(2)}
  `}
`;
